import { render, staticRenderFns } from "./ScoreLockPassword.vue?vue&type=template&id=1f29b4bb&"
import script from "./ScoreLockPassword.vue?vue&type=script&lang=js&"
export * from "./ScoreLockPassword.vue?vue&type=script&lang=js&"
import style0 from "./ScoreLockPassword.vue?vue&type=style&index=0&id=1f29b4bb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports